import useRangeSelectorStyles from 'app/tss/rangeSelector.styles'
import usePaddingStyles from 'app/tss/padding.styles'
import useLabel from 'app/hooks/useLabel'
import IntegerInput from '../IntegerInput'

export default function IntegerRangeSelector({
    from,
    to,
    onChange,
    titleFrom = 'FROM',
    titleTo = 'TO',
}: Readonly<{
    from: number,
    to: number,
    onChange: (value: { from?: number, to?: number }) => void,
    titleFrom?: string,
    titleTo?: string,
}>) {
    const l = useLabel()
    const {
        classes: rangeSelectorClasses,
        cx,
    } = useRangeSelectorStyles()

    const {
        classes: paddingClasses,
    } = usePaddingStyles({
        top: 1,
        bottom: 2,
        right: 1,
        left: 1,
    })

    return (
        <div className={cx(rangeSelectorClasses.wrapper, paddingClasses.padding)}>
            <div className={rangeSelectorClasses.inputsWrapper}>
                <div className={rangeSelectorClasses.input}>
                    <IntegerInput
                        name={titleFrom}
                        title={l(titleFrom)}
                        value={from}
                        onChange={(newValue) => {
                            onChange({
                                to,
                                from: newValue,
                            })
                        }}
                    />
                </div>
                <div className={rangeSelectorClasses.input}>
                    <IntegerInput
                        name={titleTo}
                        title={l(titleTo)}
                        value={to}
                        onChange={(newValue) => {
                            onChange({
                                from,
                                to: newValue,
                            })
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
